<div class="page-loader" *ngIf="loaderService.isLoading | async">
  <div class="spinner-border text-primary" role="status">
    <span class="sr-only">{{"Loading"|translate}}...</span>
  </div>
</div>
<div class="body-wrapper">
<router-outlet></router-outlet>
</div>

